import React from "react";
import { Box, Typography, Card, Avatar } from "@mui/material";

export const MetricCard = ({
  label,
  value,
  icon,
}: {
  label: string;
  value: string | number;
  icon: React.ReactElement;
}) => {
  const isPercentage = typeof value === "string" && value.includes("%");
  const isNegative = typeof value === "string" && value.startsWith("-");
  const isPositive =
    typeof value === "string" && !value.startsWith("-") && value !== "";

  const getTextColor = () => {
    if (!isPercentage) return "text.primary";
    if (isNegative) return "error";
    if (isPositive) return "success";
    return "text.primary";
  };

  return (
    <Card>
      <Box display="flex" alignItems="center" gap={1}>
        <Avatar>{icon}</Avatar>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography
        textAlign="right"
        variant="h6"
        fontWeight={600}
        color={getTextColor()}
      >
        {value}
      </Typography>
    </Card>
  );
};
